import {
  isInvestor,
  isInstitutional,
} from './authentication/authentication-manager'
import {
  SITE_USER_TYPE_DCIO,
  SITE_USER_TYPE_RIA,
  SITE_USER_TYPE_MF,
  SITE_USER_TYPE_529,
  SITE_USER_TYPE_RETIREMENT,
} from './environments/site'

export default function () {
  const selectedText = null

  const mobileSelect = document.querySelector('#mobile-cross-site-nav')

  // Get siteUserType from local storage
  const siteUserType = window.localStorage.getItem('SITE_USER_TYPE')

  // MOBILE - IF a different site is selected from select-option, Update siteUserType local storage
  // redirect occurs in _nav.js (crossSiteSelectElement)
  if (mobileSelect) {
    mobileSelect.addEventListener('change', (event) => {
      event.preventDefault()
      const currentTarget = event.currentTarget
      const siteUserTypeVal =
        currentTarget.options[currentTarget.selectedIndex].dataset.siteUserType

      setSiteUserType(siteUserTypeVal)
      clearUserPreference()
    })
  }

  function setSiteUserType(userType) {
    if (userType) {
      window.localStorage.setItem('SITE_USER_TYPE', userType)
      // Cookies.set('SITE_USER_TYPE', userType, getLongTermCookieOptions())
    } else {
      window.localStorage.removeItem('SITE_USER_TYPE')
      // Cookies.set('SITE_USER_TYPE', '', getLongTermCookieOptions())
    }
  }

  function clearUserPreference() {
    const saveUserPreference = localStorage.getItem('SAVE_USER_PREFERENCE')

    if (saveUserPreference) {
      localStorage.removeItem('SAVE_USER_PREFERENCE')
    }
  }

  // Set Site Selector sub header text
  const isInvestorType =
    siteUserType === SITE_USER_TYPE_MF ||
    siteUserType === SITE_USER_TYPE_529 ||
    siteUserType === SITE_USER_TYPE_RETIREMENT
  const isAdvisorType =
    siteUserType === SITE_USER_TYPE_DCIO || siteUserType === SITE_USER_TYPE_RIA

  if (
    selectedText &&
    ((isInvestor() && isInvestorType) ||
      (!isInvestor() && !isInstitutional() && isAdvisorType))
  ) {
    document.querySelector('.CtiDropdown-subHeader').innerHTML = selectedText
  }
}
